import { bunja } from 'bunja';
import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';

import { deleteUserTradeDefaultsApi, putUserTradeDefaultsApi } from '@flipster/apis/v1/user';
import { getMeQueryKey } from '@flipster/features/src/shared/auth/state';

export const defaultLeverageMarginModeBunja = bunja(() => {
  const putUserTradeDefaultsAtom = atomWithMutation((get) => ({
    mutationKey: ['putUserTradeDefaultsApi'],
    mutationFn: putUserTradeDefaultsApi,
    onSuccess: () => {
      get(queryClientAtom).invalidateQueries({ queryKey: [getMeQueryKey] });
    },
  }));

  const deleteUserTradeDefaultsAtom = atomWithMutation((get) => ({
    mutationKey: ['deleteUserTradeDefaultsApi'],
    mutationFn: deleteUserTradeDefaultsApi,
    onSuccess: () => {
      get(queryClientAtom).invalidateQueries({ queryKey: [getMeQueryKey] });
    },
  }));

  return { putUserTradeDefaultsAtom, deleteUserTradeDefaultsAtom };
});
defaultLeverageMarginModeBunja.debugLabel = 'defaultLeverageMarginModeBunja';
